import { Router, Route, Switch } from 'wouter-preact';
import { AppProviders } from './lib/contexts';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <Router>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/" component={DashboardPage} />
            <Route>
              <LoginPage />
            </Route>
          </Switch>
        </Router>
      </AppProviders>
    </ErrorBoundary>
  );
}
